import { GET_WALLET, GET_DEBITED, GET_WALLET_GRAPH } from "../constants/index";

export const wallet = (
  state = { walletlist: [], getwalletgraphdata: [], debitlist: [] },
  action
) => {
  switch (action.type) {
    case GET_WALLET:
      return { ...state, walletlist: action.walletlist };
    case GET_DEBITED:
      return { ...state, debitlist: action.debitlist };
    case GET_WALLET_GRAPH:
      return { ...state, getwalletgraphdata: action.getwalletgraphdata };
    default:
      return state;
  }
};
